var searchOpen = document.querySelectorAll("[data-search-open]");
var searchClose = document.querySelectorAll("[data-search-close]");

var searchContainer = document.querySelector("[data-search-container]");

searchOpen.forEach((el) => {
    el.addEventListener("click", () => {
        document.querySelector(".search__footer-container").classList.remove("hide");
        document.querySelector(".search__fetch-results").classList.add("hide");
        searchContainer?.classList.add("open");
    });
});

searchClose.forEach((el) => {
    el.addEventListener("click", () => {
        searchContainer?.classList.remove("open");
    });
});

// FETCH SEARCH PAGE BY PARAM

var searchResultButton = document.querySelector("[data-search-button]");
var searchInput = document.querySelector("[data-search-input]");

var searchProductsRes = document.querySelector("[data-search-product-result]");
var searchArticlesRes = document.querySelector("[data-search-article-result]");

// === Click on button
searchResultButton?.addEventListener("click", () => {
    var value = searchInput.value;

    document.querySelector(".search__footer-container").classList.add("hide");
    getSearchResults(value);
});

// === Press 'enter' on input
if (searchInput !== null && searchInput !== undefined) {
    searchInput.addEventListener('keypress', function (e) {
        if (e.key === 'Enter') {
            var value = searchInput.value;

            document.querySelector(".search__footer-container").classList.add("hide");
            getSearchResults(value);
        }
    });
}

function getSearchResults(value) {
    document.querySelector(".search__fetch-results").classList.remove("hide");
    fetch('/search?view=fetch-products&q=' + value + '*&type=product')
        .then(response => response.text())
        .then(data => {
            searchProductsRes.innerHTML = data;
        });
    fetch('/search?view=fetch-articles&q=' + value + '*&type=article')
        .then(response => response.text())
        .then(data => {
            searchArticlesRes.innerHTML = data;
        });
}

